import {
  NotificationProductCode,
  type MailTemplate,
  type MailTemplatePlaceholderView,
} from '@gb-ticket/shared-types';

/** Reiter on `/verwaltung/e-mail` — Helpdesk, Intranet, Urlaub, Fuhrpark, Wartung, Eintritt. */
export const MAIL_TEMPLATE_PRODUCT_TABS = [
  NotificationProductCode.HELPDESK,
  NotificationProductCode.INTRANET,
  NotificationProductCode.LEAVE,
  NotificationProductCode.FLEET,
  NotificationProductCode.MAINTENANCE,
  NotificationProductCode.ONBOARDING,
] as const;

/** Replace `{{token}}` from the selected template's placeholder samples. */
export function applyMailTemplatePreview(
  template: string,
  placeholders: readonly Pick<MailTemplatePlaceholderView, 'token' | 'sample'>[],
): string {
  return placeholders.reduce((text, item) => text.replaceAll(item.token, item.sample), template);
}

export function partitionMailTemplates(items: readonly MailTemplate[]): {
  emailOn: MailTemplate[];
  emailOff: MailTemplate[];
} {
  return {
    emailOn: items.filter((item) => item.emailDefault),
    emailOff: items.filter((item) => !item.emailDefault),
  };
}
